import React, { useState } from 'react';
import { Col, DatePicker, Row } from 'antd';
import { useNavigate } from '@common/hooks';
import { AddButton, AppContent, Link } from '@common/components';
import { RatesLongTermTable } from '@institutions/components';
import { useSetBreadcrumbs } from 'works/legacy/lib/client-store';
import {
  fromISODateFormat,
  ifValidOrNow,
  toISODateFormat,
  US_DATE_FORMAT,
} from 'works/legacy/lib/date-helper';
import { useQueryParam } from 'works/legacy/services/query-params-service';
import { RATES_URLS } from '@institutions/services';
import { ORGANIZATION_ADMIN_MENU } from 'works/pages/organization/admin-settings/organization-admin-vertical-nav-menu';
import { useCurrentMembership } from '@identity/hooks';

function useEffectiveDateFromQueryParam() {
  const effectiveDateParam = useQueryParam('effective-date');
  const effectiveDate = fromISODateFormat(effectiveDateParam);
  return ifValidOrNow(effectiveDate);
}

export function AdminRatesLongTermPage() {
  useSetBreadcrumbs([
    {
      name: 'Admin',
      path: '/works/admin',
    },
    {
      name: 'Rates',
      path: '/works/admin/rates',
    },
    {
      name: ORGANIZATION_ADMIN_MENU.RATES__LONG_TERM.LABEL,
      path: ORGANIZATION_ADMIN_MENU.RATES__LONG_TERM.ROUTE,
    },
  ]);
  const navigate = useNavigate();
  const currentMembership = useCurrentMembership();
  const canCreateBillingCard = currentMembership.canCreateBillingCard;
  const defaultEffectiveDate = useEffectiveDateFromQueryParam();
  const [effectiveDate, setEffectiveDate] = useState(defaultEffectiveDate);

  return (
    <>
      <AppContent className="long-term-rates-page">
        <Row justify="space-between" gutter={16} style={{ marginBottom: 16 }}>
          <Col>
            <div>
              <label style={{ display: 'block', marginLeft: 1 }}>
                Contract Start Date
              </label>
              <DatePicker
                allowClear={false}
                value={effectiveDate}
                format={US_DATE_FORMAT}
                defaultValue={effectiveDate}
                onChange={(date) => {
                  setEffectiveDate(ifValidOrNow(date));
                  navigate(
                    `${RATES_URLS.LONG_TERM}?effective-date=${toISODateFormat(
                      date
                    )}`
                  );
                }}
              />
            </div>
          </Col>
          <Col style={{ display: 'flex', flexDirection: 'column-reverse' }}>
            {canCreateBillingCard && (
              <Link to={`${RATES_URLS.LONG_TERM}/create`}>
                <AddButton>Rate Card</AddButton>
              </Link>
            )}
          </Col>
        </Row>
        <RatesLongTermTable effectiveDate={effectiveDate} />
      </AppContent>
    </>
  );
}
